var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vat-settings" },
    [
      _c(
        "div",
        { staticClass: "vat-settings__columns" },
        [
          _c(
            "Card",
            [
              _c(
                "div",
                { staticClass: "vat-settings__card-header" },
                [
                  _c("Heading", {
                    attrs: {
                      labelTitle: _vm.$t.__(
                        "settings.taxes.VatSettings.vat.title"
                      ),
                      variant: "h2",
                      prefixColoredIcon: { icon: "percent", color: "brand" }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.isLoading
                    ? _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.vat.button"
                          ),
                          type: "secondary",
                          leftIcon: "settings"
                        },
                        on: { click: _vm.openVatRateDialog }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _c("VatSettingsLoader")
                : [
                    _c(
                      "CompassFormItem",
                      {
                        staticClass: "vat-settings__form-item",
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.vat.type.label"
                          ),
                          info: _vm.$t.__(
                            "settings.taxes.VatSettings.vat.type.info"
                          )
                        }
                      },
                      [
                        _c(
                          "CompassRadioGroup",
                          {
                            attrs: { label: "", direction: "horizontal" },
                            on: { input: _vm.handleSettingsUpdate },
                            model: {
                              value: _vm.taxesSettings.vat_mode,
                              callback: function($$v) {
                                _vm.$set(_vm.taxesSettings, "vat_mode", $$v)
                              },
                              expression: "taxesSettings.vat_mode"
                            }
                          },
                          _vm._l(_vm.vatModes, function(item) {
                            return _c("CompassRadio", {
                              key: item.value,
                              attrs: {
                                modelValue: item.value,
                                label: item.label
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vat-settings__form-item--bordered" },
                      [
                        _c("CompassSwitch", {
                          staticClass: "vat-settings__switch",
                          attrs: {
                            orientation: "left",
                            label: _vm.$t.__(
                              "settings.taxes.VatSettings.vat.type.display_tax_mention"
                            )
                          },
                          on: { change: _vm.handleSettingsUpdate },
                          model: {
                            value: _vm.taxesSettings.display_tax_mention,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.taxesSettings,
                                "display_tax_mention",
                                $$v
                              )
                            },
                            expression: "taxesSettings.display_tax_mention"
                          }
                        }),
                        _vm._v(" "),
                        _vm.taxesSettings.display_tax_mention
                          ? _c(
                              "CompassFormItem",
                              {
                                attrs: {
                                  label: _vm.$t.__(
                                    "settings.taxes.VatSettings.vat.type.sales_docs.label"
                                  ),
                                  info: _vm.$t.__(
                                    "settings.taxes.VatSettings.vat.type.sales_docs.info"
                                  )
                                }
                              },
                              [
                                _c("CompassInput", {
                                  attrs: { maxlength: "255" },
                                  on: {
                                    "update:value": _vm.handleSettingsUpdate
                                  },
                                  model: {
                                    value: _vm.taxesSettings.vat_mention,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.taxesSettings,
                                        "vat_mention",
                                        $$v
                                      )
                                    },
                                    expression: "taxesSettings.vat_mention"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.vat.default_vat.label"
                          ),
                          info: _vm.$t.__(
                            "settings.taxes.VatSettings.vat.default_vat.info"
                          )
                        }
                      },
                      [
                        _c(
                          "CompassSelect",
                          {
                            on: { "update:value": _vm.handleSettingsUpdate },
                            model: {
                              value: _vm.taxesSettings.vat_id,
                              callback: function($$v) {
                                _vm.$set(_vm.taxesSettings, "vat_id", $$v)
                              },
                              expression: "taxesSettings.vat_id"
                            }
                          },
                          _vm._l(_vm.filteredActiveTaxes, function(item) {
                            return _c("CompassDropdownSelectOption", {
                              key: item.id,
                              attrs: {
                                label: _vm._f("taxeLabel")(item),
                                value: item.id
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vat-settings__columns--right" },
            [
              _c(
                "Card",
                [
                  _c(
                    "div",
                    { staticClass: "vat-settings__card-header" },
                    [
                      _c("Heading", {
                        attrs: {
                          labelTitle: _vm.$t.__(
                            "settings.taxes.VatSettings.ecotax.title"
                          ),
                          variant: "h2",
                          prefixColoredIcon: { icon: "leaf", color: "brand" }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.isLoading
                        ? _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "settings.taxes.VatSettings.ecotax.button"
                              ),
                              type: "secondary",
                              leftIcon: "settings"
                            },
                            on: { click: _vm.openEcoTaxDialog }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c("VatSettingsLoader", { attrs: { lines: 1 } })
                    : _c("CompassSwitch", {
                        staticClass: "vat-settings__switch",
                        attrs: {
                          orientation: "left",
                          label: _vm.$t.__(
                            "settings.taxes.VatSettings.ecotax.switch.label"
                          )
                        },
                        on: { change: _vm.handleSettingsUpdate },
                        model: {
                          value: _vm.taxesSettings.use_ecotax,
                          callback: function($$v) {
                            _vm.$set(_vm.taxesSettings, "use_ecotax", $$v)
                          },
                          expression: "taxesSettings.use_ecotax"
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Card",
                [
                  _c("Heading", {
                    attrs: {
                      labelTitle: _vm.$t.__(
                        "settings.taxes.VatSettings.discount.title"
                      ),
                      variant: "h2",
                      prefixColoredIcon: {
                        icon: "rosette-discount-check",
                        color: "brand"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c("VatSettingsLoader")
                    : [
                        _c("CompassSwitch", {
                          staticClass: "vat-settings__switch",
                          attrs: {
                            orientation: "left",
                            label: _vm.$t.__(
                              "settings.taxes.VatSettings.discount.switch.label"
                            )
                          },
                          on: { change: _vm.handleSettingsUpdate },
                          model: {
                            value: _vm.taxesSettings.use_bonuses,
                            callback: function($$v) {
                              _vm.$set(_vm.taxesSettings, "use_bonuses", $$v)
                            },
                            expression: "taxesSettings.use_bonuses"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "CompassFormItem",
                          {
                            staticClass: "vat-settings__discount-form-item",
                            attrs: {
                              label: _vm.$t.__(
                                "settings.taxes.VatSettings.discount.default_discounts"
                              )
                            }
                          },
                          [
                            _c("CompassInputUnit", {
                              attrs: {
                                unit: _vm.taxesSettings.discount.type,
                                options: _vm.discountOptions,
                                type: "number",
                                min: 0
                              },
                              on: {
                                select: _vm.handleSettingsUpdate,
                                "update:value": _vm.handleSettingsUpdate
                              },
                              model: {
                                value: _vm.taxesSettings.discount.value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.taxesSettings.discount,
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "taxesSettings.discount.value"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("CompassSwitch", {
                          staticClass: "vat-settings__switch",
                          attrs: {
                            orientation: "left",
                            label: _vm.$t.__(
                              "settings.taxes.VatSettings.discount.discount_per_row"
                            )
                          },
                          on: { change: _vm.handleSettingsUpdate },
                          model: {
                            value: _vm.taxesSettings.discount.by_rows,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.taxesSettings.discount,
                                "by_rows",
                                $$v
                              )
                            },
                            expression: "taxesSettings.discount.by_rows"
                          }
                        })
                      ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Card",
        [
          _c(
            "div",
            { staticClass: "vat-settings__card-header" },
            [
              _c("Heading", {
                attrs: {
                  labelTitle: _vm.$t.__(
                    "settings.taxes.VatSettings.rates.title"
                  ),
                  variant: "h2",
                  prefixColoredIcon: { icon: "list-details", color: "brand" }
                }
              }),
              _vm._v(" "),
              !_vm.isLoading
                ? _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "settings.taxes.VatSettings.rates.button"
                      )
                    },
                    on: { click: _vm.openRateCategoryDialog }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c("RateCategoryTable", {
                attrs: {
                  rateCategories: _vm.rateCategories,
                  metadata: _vm.rateCategoriesMetadata,
                  taxes: _vm.taxes
                },
                on: {
                  "delete-rate-category": _vm.deleteCategory,
                  "edit-rate-category": _vm.editCategory,
                  "change-default-rate": _vm.changeDefaultRate
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }